export default Object.freeze({
  ALL_MATERIALS_TITLE: 'Materials-X',
  MATERIAL_PREVIEW_SCALE: 0.954,
});
